/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Summaryliveroomtitle3Inputs */

const en_summaryliveroomtitle3 = /** @type {(inputs: Summaryliveroomtitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Live Room`)
};

const de_summaryliveroomtitle3 = /** @type {(inputs: Summaryliveroomtitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Live Room`)
};

/**
* | output |
* | --- |
* | "Live Room" |
*
* @param {Summaryliveroomtitle3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const summaryliveroomtitle3 = /** @type {((inputs?: Summaryliveroomtitle3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Summaryliveroomtitle3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_summaryliveroomtitle3(inputs)
	return de_summaryliveroomtitle3(inputs)
});
export { summaryliveroomtitle3 as "summaryLiveRoomTitle" }